<template>
  <div class="navi">
    <router-link :to='getLinkTarget("UserManage", "/philips/master/user/InternalUserSearch")'>
      <div :class='getClass("UserManage")'>
        <b-icon icon="account-multiple" />ユーザー管理
      </div>
    </router-link>
    <router-link :to='getLinkTarget("NoticeEdit", "/philips/master/notice/NoticeEdit")'>
      <div :class='getClass("NoticeEdit")'>
        <b-icon icon="chat-alert-outline" />お知らせ管理
      </div>
    </router-link>
    <router-link :to='getLinkTarget("MasterMaint", "/philips/master/master/MasterMaint")'>
      <div :class='getClass("MasterMaint")'>
        <b-icon icon="grid" />マスター管理
      </div>
    </router-link>
    <router-link :to='getLinkTarget("AgreementEdit", "/philips/master/agreement/AgreementEdit")'>
      <div :class='getClass("AgreementEdit")'>
        <b-icon icon="file-document-outline" />同意文管理
      </div>
    </router-link>
    <router-link :to='getLinkTarget("ListEdit", "/philips/master/list/ListEdit")'>
      <div :class='getClass("ListEdit")'>
        <b-icon icon="format-list-checks " />リスト編集
      </div>
    </router-link>
    <router-link :to='getLinkTarget("ExamItemsEdit", "/philips/master/list/ExamItemsEdit")'>
      <div :class='getClass("ExamItemsEdit")'>
        <b-icon icon="clipboard-pulse-outline" />検査品目
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "MasterMaintenanceBar",
  props: ["pageid"],
  methods: {
    getLinkTarget: function(tabkind, target) {
      var ret = target;
      if (tabkind == this.pageid) {
        ret = "";
      }
      return ret;
    },
    getClass: function(tabkind) {
      var ret = "tabLabel ";
      if (tabkind == this.pageid) {
        ret += "active";
      } else {
        ret += "deactive";
      }
      return ret;
    }
  },
  data() {
    return {};
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.navi {
  height: 20px;
  margin-top: -20px;
}
.tabLabel {
  float: left;
  text-align: center;
  border-radius: 10px 10px 0px 0px;
  border-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
  width: 150px;
  height: 30px;
}
.tabLabel.active {
  color: white;
  border-color: #000894;
  background-color: #000894;
}
.tabLabel.deactive {
  border-color: #f7f7f7;
  background-color: #e4e4e4;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/master/MasterMaintenanceBar.vue